import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  SpModalAudienceScoreInformationComponent
} from '../sp-modal-audience-score-information/sp-modal-audience-score-information.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  // Ensures score is a required field
  // Using Angular "official way"
  selector: 'app-sp-audience-score[score]',
  templateUrl: './sp-audience-score.component.html',
  styleUrls: ['./sp-audience-score.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SpAudienceScoreComponent {
  protected readonly scoreConfig = new Map<string, {msg: string, containerClass: string, dotClass: string, badgeClass: string, badgeColor: string}>(
    [
      ['size_too_low', {msg: "Size is too small", containerClass: 'sp-audience-fb-score-too-low', dotClass: 'sp-audience-fb-score-dot-too-low', badgeClass: 'badge-size-too-low', badgeColor: '#C62F38'}],
      ['size_low', {msg: "Size is small", containerClass: 'sp-audience-fb-score-low', dotClass: 'sp-audience-fb-score-dot-low', badgeClass: 'badge-size-low', badgeColor: '#EDAA3B'}],
      ['size_good', {msg: "Size is good", containerClass: 'sp-audience-fb-score-good', dotClass: 'sp-audience-fb-score-dot-good', badgeClass: 'badge-size-good', badgeColor: '#3981F7'}],
      ['size_perfect', {msg: "Size is perfect", containerClass: 'sp-audience-fb-score-perfect', dotClass: 'sp-audience-fb-score-dot-perfect', badgeClass: 'badge-size-perfect', badgeColor: '#4CB076'}],
      ['size_high', {msg: "Size is big", containerClass: 'sp-audience-fb-score-high', dotClass: 'sp-audience-fb-score-dot-high', badgeClass: 'badge-size-high', badgeColor: '#EDAA3B'}],
      ['size_too_high', {msg: "Size is too big", containerClass: 'sp-audience-fb-score-too-high', dotClass: 'sp-audience-fb-score-dot-too-high', badgeClass: 'badge-size-too-high', badgeColor: '#C62F38'}]
    ]
  )

  @Input() score!: string;
  @Input() variant: 'indicator' | 'badge' = 'indicator';
  @Input() audienceSize?: number;

  constructor(private dialog: MatDialog) {}

  getAudienceScoreInformation() {
    this.dialog.open(SpModalAudienceScoreInformationComponent,{autoFocus: false,
      minHeight:'496px',
      width:'520px',
    });
  }

  get audienceScoreIndicator(): string {
    return this.score;
  }

  formatNumber(num: number): string {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  }

  get badgeConfig() {
    return this.scoreConfig.get(this.audienceScoreIndicator);
  }
}
